import React from 'react';
import { Table } from 'react-bootstrap';
import { CandidateRow } from './candidate-row';
import { useStudents } from '../hooks/use-students';

export const CandidatesList = () => {
    const { students, isLoading } = useStudents();
    const renderCandidate = (student, key) => (
        <CandidateRow
            key={key}
            student={student}
        />
    );
    return isLoading ? null : (
        <Table striped bordered hover size="sm">
            <tbody>
                {students.map(renderCandidate)}
            </tbody>
        </Table>
    );
};
